import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardStatisticsComponent } from './dashboard-statistics.component';
import { PageHeaderModule } from '../../../core/page-header/page-header.module';
import { BreadcrumbsModule } from '../../../core/breadcrumbs/breadcrumbs.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { StateWidgetModule } from './state-widget/state-widget.module';
import { BarchartWidgetModule } from './barchart-widget/barchart-widget.module';
import { AreachartWidgetModule } from './areachart-widget/areachart-widget.module';
import { RecentsalesWidgetModule } from './recentsales-widget/recentsales-widget.module';
import { AdvancedPieChartWidgetModule } from './advanced-pie-chart-widget/advanced-pie-chart-widget.module';
import { MarketWidgetModule } from '../dashboard-crm/market-widget/market-widget.module';
import { MapsWidgetModule } from './maps-widget/maps-widget.module';
import { SalesWidgetModule } from './sales-widget/sales-widget.module';
import { ProjectWidgetModule } from '../dashboard-crm/project-widget/project-widget.module';
import { DashboardStatisticsRoutingModule } from './dashboard-statistics-routing.module';
import {
    MatButtonModule,
    MatCard,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule, MatIconModule,
    MatTableModule, MatTooltipModule
} from '@angular/material';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule} from '@angular/forms';
import {AngularCountdownTimerModule} from 'angular8-countdown-timer';
import {CdkTableModule} from '@angular/cdk/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {SeasonsModule} from '../../seasons/seasons.module';
import {RaceSignupComponent} from '../../seasons/race-signup/race-signup.component';
import {SignupDialogComponent} from '../../seasons/race-signup/signup-dialog/signup-dialog.component';
import {LayoutModule} from '../../../core/layout/layout.module';
import {FooterModule} from '../../footer/footer.module';
import {UpcomingBroadcastsComponent} from '../upcoming-broadcasts/upcoming-broadcasts.component';
import { NewsComponent } from './news/news.component';
import { RacingStatsComponent } from './racing-stats/racing-stats.component';
import {AdsenseModule} from 'ng2-adsense';
import {PagesModule} from '../../pages.module';
import {MatTabsModule} from '@angular/material';
import {AdServiceModule} from '../../ad-service/ad-service.module';
import {SeriesChooserModule} from '../../series-chooser/series-chooser.module';
import {YearlyrecapModule} from '../../yearlyrecap/yearlyrecap.module';
import {YearlyrecapComponent} from '../../yearlyrecap/yearlyrecap.component';
import {ListModule} from '../../../core/list/list.module';

@NgModule({
    imports: [
        CommonModule,
        DashboardStatisticsRoutingModule,
        PageHeaderModule,
        BreadcrumbsModule,

        FlexLayoutModule,

        // Widgets
        StateWidgetModule,
        BarchartWidgetModule,
        AreachartWidgetModule,
        RecentsalesWidgetModule,
        AdvancedPieChartWidgetModule,
        MarketWidgetModule,
        MapsWidgetModule,
        SalesWidgetModule,
        ProjectWidgetModule,
        MatCardModule,
        MatGridListModule,
        MatMenuModule,
        MatDividerModule,
        FormsModule,
        MatCardModule,
        MatExpansionModule,
        MatDialogModule,
        MatTableModule,
        AngularCountdownTimerModule,
        MatTableModule,
        CdkTableModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatIconModule,
        SeasonsModule,
        LayoutModule,
        FooterModule,
        AdsenseModule,
        PagesModule,
        MatTabsModule,
        MatButtonModule,
        AdServiceModule,
        SeriesChooserModule,
        YearlyrecapModule,
        ListModule
    ],
  declarations: [DashboardStatisticsComponent, UpcomingBroadcastsComponent, NewsComponent, RacingStatsComponent],
  exports: [DashboardStatisticsComponent],
  entryComponents: [SignupDialogComponent, YearlyrecapComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class DashboardStatisticsModule { }
